import { Battle } from './Battle';
import { Result } from './Result';
import { TimeAttributes } from '@/interfaces/TimeAttributes';
import { User } from '@/modules/admin/interfaces/User';

export interface BattleComment extends TimeAttributes {
  id: string | number;
  uuid?: string;
  content?: string;
  type: (typeof BattleCommentsTypes)[keyof typeof BattleCommentsTypes];
  verdict: { [key: string]: Result | null };
  date: string;
  battle?: Battle;
  public: boolean;
  user?: User;
  isFirstJudge?: boolean;
}

export interface BattleCommentCreate extends Omit<BattleComment, 'user' | 'id' | 'battle'> {
  battle: string | number;
  userId?: string | number;
}

export type BattleCommentUpdate = Partial<BattleCommentCreate>;

export const BattleCommentsTypes = {
  TRIVIUM: 'trivium',
  THREEFOLD: 'threefold',
  CLASSIC: 'classic',
  TYPE_A: 'typeA',
  TYPE_B: 'typeB',
} as const;

export type BattleCommentsType = 'trivium' | 'threefold' | 'classic' | 'typeA' | 'typeB';

export const BattleCommentsNames = {
  [BattleCommentsTypes.TRIVIUM]: 'Trivium',
  [BattleCommentsTypes.THREEFOLD]: 'ThreeFold',
  [BattleCommentsTypes.CLASSIC]: 'Classic',
  [BattleCommentsTypes.TYPE_A]: 'Type A',
  [BattleCommentsTypes.TYPE_B]: 'Type B',
};

export const BattleCommentsViews = {
  PUBLIC: 'public',
  PRIVATE: 'private',
};

export const BattleCommentsViewNames = {
  [BattleCommentsViews.PUBLIC]: 'Public',
  [BattleCommentsViews.PRIVATE]: 'Private',
};
